// Your web app's Firebase configuration
// const firebaseConfig = {
//     apiKey: "AIzaSyDwrMirSrY12PDKJmkbex1-J6D8mLL7H6Y",
//     authDomain: "lifecare-hospital-3295a.firebaseapp.com",
//     projectId: "lifecare-hospital-3295a",
//     storageBucket: "lifecare-hospital-3295a.appspot.com",
//     messagingSenderId: "1011497141982",
//     appId: "1:1011497141982:web:b9521850c167f7ecf3644f"
// };

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyC4ZavMnJCH2dEUrJHqxed-JruZfgL6jDY",
    authDomain: "life-care-hospital-4f97f.firebaseapp.com",
    projectId: "life-care-hospital-4f97f",
    storageBucket: "life-care-hospital-4f97f.appspot.com",
    messagingSenderId: "546817069995",
    appId: "1:546817069995:web:e1d6ab216bec1dfbc6b8ee"
};

export default firebaseConfig;